/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

export interface FinancingSourcesLeasingsVariantsDestroy$Params {
  /**
   * A unique integer value identifying this leasing contract variant.
   */
  id: number;
}

export function financingSourcesLeasingsVariantsDestroy(
  http: HttpClient,
  rootUrl: string,
  params: FinancingSourcesLeasingsVariantsDestroy$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesLeasingsVariantsDestroy.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as BakendHttpResponse<void>;
    }),
  );
}

financingSourcesLeasingsVariantsDestroy.PATH = '/api/financing_sources/leasings_variants/{id}/';
